/* ADD POLL */
export const ADD_POLL = "ADD_POLL"
export const ADD_POLL_SUCCESS = "ADD_POLL_SUCCESS"
export const ADD_POLL_CLEAN = "ADD_POLL_CLEAN"
export const ADD_POLL_ERROR = "ADD_POLL_ERROR"
